import React, { Fragment } from "react";
import Image from "react-bootstrap/Image";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/MainBody.scss";
import SocialMediaRow from "./SocialMediaRow";
import Particles from 'react-particles-js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faImages} from '@fortawesome/free-regular-svg-icons';

// const landingImg = "/assets/images/blur-main.jpg";
const landingImg = "/assets/images/light-bulb-1246043.jpg";
const portrait = "/assets/images/bro1.png";

const marginSpacer = "mt-5";

const fullScreenStyle = (bgImg: string) => {
  return {
    backgroundImage: `url(${bgImg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100vw",
    height: "100vh",
  };
};

export default function MainBody() {
  const particleParams = {
    "particles": {
      "color": "#fff4e1",
      "number": {
        "value": 260,
        "density": {
          "enable": true
        }
      },
      "size": {
        "value": 3,
        "random": true,
        "anim": {
          "speed": 4,
          "size_min": 0.3
        }
      },
      "line_linked": {
        "enable": false
      },
      "move": {
        "random": true,
        "speed": 2,
        "direction": "left",
        "out_mode": "out"
      }
    },
    "interactivity": {
      "events": {
        "onhover": {
          "enable": true,
          "mode": "repulse"
        },
        "onclick": {
          "enable": true,
          "mode": "push"
        }
      },
      "modes": {
        "grab": {
          "distance": 250,
          "opacity": 1,

        },
        "repulse": {
          "distance": 150,
          "duration": 70,
        },
      }
    }
  }
  return (
    <Fragment>
      <Container fluid>
        <Row>
          <div style={fullScreenStyle(landingImg)}>
            <h1 className="titleText centerVerticalHorizantal">
              Hello World, I am Mohammed!
            </h1>
            {/* @ts-ignore */}
            <Particles params={particleParams} id="particlesLandingPage"/>
          </div>
        </Row>

        <Row style={{ overflowX: "hidden" }}>
          <Container className={marginSpacer + " sectionText"}>
            <h1>About me</h1>
          </Container>
          <Row className={marginSpacer} >
            <Col sm={3} className="px-3">
              <Image className="portraitStyle mt-5" src={portrait} />
            </Col>
            <Col>
              <div style={{ color: "white", textAlign: "left" }} className="mt-5 m-2 p-1">
                <p >
                  I am a software developer who loves going on adventures! I graduated with Honors from the University of Ottawa with a degree in Electrical Engineering. I love training machine learning models and applying them to real world problems (CNNs and Transformers are awesome!). I also like
                  robotics, designing circuits, swimming, running and the great outdoors.
                </p>
                <p>
                  <b>Software and Machine Learning</b>:<br/> 
                  - Professional Software Development experience with a couple of
                  Canadian companies (full list in my Linkedin profile linked below).
                  <br/> 
                  - Deep learning with Tensorflow and Pytorch (but I like Pytorch better).
                  <br/> 
                  - Most of the time I code with Python, Javascript, Ruby, Java, Go, C++, and Lua.
                  <br/> 
                  - Developed few mobile apps, with both Flutter and Android studio.
                  <br/> 
                  - Made games with Unreal and Unity engines.
                  <br/> 
                  - Deployed my fullstack applications (ReactJS, NodeJS, SQL, and Firebase).
                  <br/> 
                  - Won best IOT hack for uottahack MLH hackathon 2019 woohoo!.
                  <br/> 
                  - Used a pre-trained artificial intelligence model for pointcloud vision for a university project robot.

                  <br/> <br/> 
                  <b>Electrical Engineering</b>:<br/> - Built countless circuits and analyzed them with testing tools (mostly oscilloscope, power supply, waveform generator and spectrum analyzer).
                  <br/>
                   - Simulated and designed circuits with with SPICE.
                   <br/>
                   - Made many Arduino/RaspberryPi projects me and my team built a solar-powered zero carbon footprint automated shed (Yes we built a real size shed, and the automation was my part).
                   <br/>
                   - Built an FPGA computer from scratch with Quartus and Altera.
                   <br/>
                   - Designed PID controllers with MATLAB and Octave.
                   <br/>
                   - Good knowledge of common Digital Signal Processing techniques.
                   <br/>
                   - Robotics design with ROS and simulation using Gazebo and CoppeliaSim.
                   <br/>
                   - RISC MCU assembly and embedded development.
                   <br/>
                   - Basic VLSI CMOS logic layout (N-well technology).
                   <br/>
                   - Writing low level driver code.
                   
                  <br />
                  <br/> 

                  <b>Other</b>:<br/> 
                   - Using 3D printers and modeling software (Blender, FreeCAD, and OpenSCAD).
                      <br/>
                   - Using machine shop tools, like lathe, and drill press.
                    <br/>
                   - Won best IOT hack at an MLH hackathon - UOTTAHACK 2019.
                    <br/>
                   - Graduated with honors, and was in the dean's honor list.
                    <br/>
                   - Won uottaWow photography contest - University of Ottawa 2016.
                    <br/>
                   - Had a meeting with Ottawa Business Journal <a href="https://obj.ca/ottawa-entrepreneurs-carve-out-tourism-niche-by-offering-unique-experiences/">link.</a>
                    <br/>
                    - Fluent in Arabic and English. Beginner in French.
                    <br/> 

                </p>
                
              </div>
            </Col>
          </Row>
        </Row>
        <Row className={marginSpacer}>
          <Col className="sectionText pt-5">

            <h1  className="pb-3 m-1" style={{ textAlign: "center" }}>Photography</h1>
            <a style={{ color:"lightgrey" }}
            href="https://pixabay.com/users/brilliant_ember-18238877/">
              <h4>
              <FontAwesomeIcon size="lg" style={{paddingRight:"3px"}}  icon={faImages} />

              You can check my profile on PixelBay where I post some of my photos
              </h4></a>
          </Col>
        </Row>
        {/* <Row className={marginSpacer}>
          <Col className="sectionText">
            <h1>Writings</h1>
          </Col>
        </Row> */}
        <Row className={marginSpacer}>
          <Col className="sectionText py-5">
            <h1>Contact</h1>
            <SocialMediaRow />
          </Col>
        </Row>
      </Container>

    </Fragment>
  );
}
